import React, { useEffect } from "react";
import { getBusinessAccount } from "../service/api";
import { useQuery } from "react-query";
import { Select, Button, Skeleton } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";

const HeaderPart = ({ action, paymentLinkModal, changeBusinessAccount }) => {
    const currentUser = JSON.parse(sessionStorage.getItem('authUser'));
    const merchantId = currentUser?.user?.id || currentUser?.user?.merchantId;
    const role = currentUser?.roles;
    const permissions = currentUser?.user?.permissions;
    const isAuthorized = role == 'COLLABORATOR' ? permissions?.includes('CREATE_PAYMENT_LINK') : true;

    const { data: businessAccountList, isLoading, error: businessAccountError } = useQuery({
        queryKey: ['businessAccounts', merchantId, currentUser.token],
        queryFn: getBusinessAccount
    });
    const businessAccounts = businessAccountList || [];

    useEffect(() => {
        if (businessAccounts.length > 0) {
            changeBusinessAccount(businessAccounts[0]);
        }
    }, [businessAccountList]);

    const showCreateModal = () => {
        action("Créer");
        paymentLinkModal(true);
    }


    return (
        <div>
            <div className='title-page mb-3'>
                Lien de paiement
            </div>
            <div className="col-12 col-md-4">
                {
                    !isLoading && !businessAccountError && businessAccounts.length > 0 && (
                        <Select
                            size="middle"
                            onChange={(value) => {
                                const selectedBusiness = businessAccounts.find(
                                    (b) => b.id.toString() === value
                                );

                                if (selectedBusiness) {
                                    changeBusinessAccount(selectedBusiness);
                                }
                            }}
                            className="col-7"
                            defaultValue={businessAccounts[0].id.toString()}
                            options={
                                Array.isArray(businessAccounts)
                                    ? businessAccounts.map((businessAccount) => ({
                                        value: businessAccount.id.toString(),
                                        label: businessAccount.businessName,
                                    }))
                                    : []
                            }

                        />
                    )

                }
                {
                    isLoading && <Skeleton.Input
                        active
                        size="default"
                        style={{ width: 200 }}
                    />
                }
                {
                    businessAccountError && <Skeleton.Input
                        disabled
                        size="default"
                        style={{ width: 200 }}
                    />
                }

            </div>
            <div className="mt-4">
                <Button
                    className="table-btn"
                    onClick={showCreateModal}
                    disabled={!isAuthorized}
                >
                    <PlusCircleOutlined /> {isAuthorized ? 'Créer un nouveau lien' : 'Pas autorisé à créer un lien' } 
                </Button>
            </div>
        </div>);
}

export default HeaderPart;